import { Component, inject } from '@angular/core';
import {
  MatDialogRef,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

/**
 * Confirmation dialog shown before submitting the intake form.
 *
 * Returns `true` when the user clicks "Yes" (confirm),
 * or `false` / `undefined` when the user clicks "No" or closes.
 */
@Component({
  selector: 'app-submit-confirmation-dialog',
  standalone: true,
  imports: [MatDialogContent, MatDialogActions, MatButtonModule],
  templateUrl: './submit-confirmation-dialog.component.html',
  styleUrl: './submit-confirmation-dialog.component.scss',
})
export class SubmitConfirmationDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<SubmitConfirmationDialogComponent>);

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
